/* eslint-disable factorial/no-raw-html */
import { ConnectionLineComponent, getSmoothStepPath } from '@xyflow/react'

import { NodeUI } from 'modules/workflows/components/Node/types'

export const ConnectionLine: ConnectionLineComponent<NodeUI> = ({
  fromX,
  fromY,
  fromPosition,
  toX,
  toY,
  toPosition,
}) => {
  const color = '#69DAE5'

  const [edgePath] = getSmoothStepPath({
    sourceX: fromX,
    sourceY: fromY,
    sourcePosition: fromPosition,
    targetX: toX,
    targetY: toY,
    targetPosition: toPosition,
  })

  return (
    <g>
      <path fill="none" stroke={color} strokeWidth={1.5} className="animated" d={edgePath} />
      <circle cx={toX} cy={toY} fill="#fff" r={3} stroke={color} strokeWidth={1.5} />
    </g>
  )
}
